<div class="container mt-4">
    <h2>Edit Profile</h2>
  
    <!-- Success Alert -->
    <div *ngIf="showSuccess" class="alert alert-success" role="alert">
      Profile updated successfully!
    </div>
  
    <!-- Spinner -->
    <div *ngIf="isLoading" class="text-center my-4">
      <div class="spinner-border" role="status"></div>
    </div>
  
    <!-- Profile Form -->
    <div class="d-flex justify-content-end mb-3">
      <button *ngIf="!isEditMode" class="btn btn-secondary" (click)="toggleEditMode()">Edit</button>
      <div *ngIf="isEditMode">
        <button type="submit" class="btn btn-primary me-2" [disabled]="isLoading || profileForm.invalid">Save Changes</button>
        <button type="button" class="btn btn-outline-secondary" (click)="toggleEditMode()">Cancel</button>
      </div>
    </div>
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" *ngIf="!isLoading" novalidate>
      <div class="mb-3">
        <label for="firstName" class="form-label">First Name</label>
        <input
          id="firstName"
          type="text"
          class="form-control"
          formControlName="firstName"
          [class.is-invalid]="f.firstName.touched && f.firstName.invalid"
          [readonly]="!isEditMode"
        />
        <div class="invalid-feedback" *ngIf="f.firstName.touched && f.firstName.errors">
          <div *ngIf="f.firstName.errors.required">First Name is required.</div>
          <div *ngIf="f.firstName.errors.minlength">Minimum 2 characters required.</div>
        </div>
      </div>
  
      <div class="mb-3">
        <label for="lastName" class="form-label">Last Name</label>
        <input
          id="lastName"
          [readonly]="!isEditMode"
          type="text"
          class="form-control"
          formControlName="lastName"
          [class.is-invalid]="f.lastName.touched && f.lastName.invalid"
        />
        <div class="invalid-feedback" *ngIf="f.lastName.touched && f.lastName.errors">
          <div *ngIf="f.lastName.errors.required">Last Name is required.</div>
          <div *ngIf="f.lastName.errors.minlength">Minimum 2 characters required.</div>
        </div>
      </div>
  
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          type="email"
          [readonly]="!isEditMode"
          class="form-control"
          formControlName="email"
          [class.is-invalid]="f.email.touched && f.email.invalid"
        />
        <div class="invalid-feedback" *ngIf="f.email.touched && f.email.errors">
          <div *ngIf="f.email.errors.required">Email is required.</div>
          <div *ngIf="f.email.errors.email">Invalid email format.</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">New Password</label>
        <input
          id="password"
          type="password"
          [readonly]="!isEditMode"
          class="form-control"
          formControlName="password"
          [class.is-invalid]="f.password.touched && f.password.invalid"
        />
        <div class="invalid-feedback" *ngIf="f.password.touched && f.password.errors">
          <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters.</div>
        </div>
      </div>
      <div class="mb-3">
        <label for="confirmPassword" class="form-label">Confirm New Password</label>
        <input
          id="confirmPassword"
          type="password"
          class="form-control"
          [readonly]="!isEditMode"
          formControlName="confirmPassword"
          [class.is-invalid]="
            profileForm.errors?.passwordMismatch && f.confirmPassword.touched
          "
        />
        <div class="invalid-feedback" *ngIf="profileForm.errors?.passwordMismatch && f.confirmPassword.touched">
          Passwords do not match.
        </div>
      </div>
      <button type="submit" class="btn btn-primary" [disabled]="isLoading">Save Changes</button>
    </form>
  </div>
  